// extracted by css-extract-rspack-plugin
export default {"container":"container-y7qOui"};